export default "__VITE_ASSET__0d2b9461__"